import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./SignUp.css";

const SignUp: React.FC = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const templateParams = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
        };

        emailjs.send(
            'service_8b5jf49',  // Replace with your EmailJS Service ID
            'template_xvtdrd6', // Replace with your EmailJS Template ID
            templateParams,
            'UomUdubQI35pd9sTm'  // Replace with your EmailJS Public Key
        )
        .then((response) => {
            console.log("Signup email sent successfully:", response);
            alert("Thank you for signing up! You'll receive updates soon.");
            setFormData({ firstName: "", lastName: "", email: "" }); // Reset form
        })
        .catch((error) => {
            console.error("Error sending signup email:", error);
            alert("Failed to sign up. Please try again.");
        });
    };

    return (
        <div className="Sign_Up_Container">
            <div className="Early_SignUp_Text">
                <h1>Early Sign Ups</h1>
                <label className="SignUp_Text_Details">
                    Join our mailing list for updates, including notifications when Phase is available to download.
                </label>
            </div>
            <div className="Submit_container">
                <form onSubmit={handleSubmit}>
                    <div className="Form_Container">
                        <input 
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                        />
                        <input 
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                        />
                        <input 
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <button className="button" type="submit">Sign Up</button>
                </form>
            </div>
            <div className="Privacy_text">
                <label>We respect your privacy. Please read our privacy and terms regarding any information you share with us. Thank you.</label>
            </div>
        </div>
    );
};

export default SignUp;
